import { showNotice } from "./services/notice_service";

const originalFetch = window.fetch;

window.fetch = async function (...args) {
  const response = await originalFetch(...args);
  const msg = response.headers.get("X-Flash-Message");

  if (msg) showNotice(msg);

  return response;
};
